import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from 'src/store';
import { AlertTypes } from 'src/store/alert/types';

import './Alert.scss';
import { hideAlert } from 'src/store/alert/actions';

interface PropsFromState {
  visible: boolean;
  type: AlertTypes;
  message: string;
  hideAlert: typeof hideAlert;
}

type AllProps = PropsFromState;

class Alert extends React.Component<AllProps> {
  public render() {
    const { visible, type, message } = this.props;
    return (
      <div
        className={'alert container' + (visible ? '' : ' hidden')}
        onClick={() => {
          this.props.hideAlert();
        }}
      >
        <div className={`wrapper ${type}`}>
          <span>{message}</span>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  hideAlert: () => dispatch(hideAlert())
});

const mapStateToProps = ({ alerts }: ApplicationState) => ({
  visible: alerts.visible,
  type: alerts.type,
  message: alerts.message
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Alert);



// WEBPACK FOOTER //
// ./src/components/utils/Alert/Alert.tsx